export const tagging = [{
    url: '/login',
    title: 'Login',
    tagName: 'Login',
}, {
    url: '/prelogin/search-result/product-line',
    title: 'Pre Search Result Product Line',
    tagName: 'PreSearchResultProductLine',
}, {
    url: '/prelogin/search-result/product-number',
    title: 'Pre Search Result Product Number',
    tagName: 'PreSearchResultProductNumber',
}, {
    url: '/prelogin/product-specs/product-number/',
    title: 'Pre Product Specs Page Product Number',
    tagName: 'PreProductSpecsPageProductNumber',
}, {
    url: '/prelogin/product-specs/product-line/',
    title: 'Pre Product Specs Page Product Line',
    tagName: 'PreProductSpecsPageProductLine',
}, {
    url: '/prelogin/ge-custnet-registration',
    title: 'GE CustomerNet Registration',
    tagName: 'GECustomerNetRegistration',
}, {
    url: '/prelogin/ge-custnet-registration/confirmation',
    title: 'GE CustomerNet Registration Confirmation',
    tagName: 'GECustomerNetRegistrationConfirmation',
}, {
    url: '/prelogin/no-account',
    title: 'No Account Found Page',
    tagName: 'NoAccountFoundPage',
}, {
    url: '/prelogin/request-access',
    title: 'Request Access',
    tagName: 'RequestAccess',
}, {
    url: '/prelogin/forgot-password',
    title: 'Forgot Password',
    tagName: 'ForgotPassword',
}, {
    url: '/prelogin/request-access-confirmation',
    title: 'Request Access Confirmation',
    tagName: 'RequestAccessConfirmation',
}, {
    url: '/prelogin/error',
    title: 'Error Page',
    tagName: 'ErrorPage',
}, {
    url: '/prelogin/',
    title: '',
    tagName: '',
}, {
    url: '/prelogin/',
    title: '',
    tagName: '',
}, {
    url: '/home',
    title: 'Home Page',
    tagName: 'HomePage',
}, {
    url: '/siteManagement',
    title: 'Site Management',
    tagName: 'SiteManagement',
}, {
    url: '/asset/create',
    title: 'Asset Create',
    tagName: 'AssetCreate',
}, {
    url: '/asset/edit',
    title: 'Asset Edit',
    tagName: 'AssetEdit',
}, {
    url: '/search-result/product-line/',
    title: 'Post Search Result Product Line',
    tagName: 'PostSearchResultProductLine',
}, {
    url: '/search-result/product-number/',
    title: 'Post Search Result Product Number',
    tagName: 'PostSearchResultProductNumber',
}, {
    url: '/product-specs/product-number/',
    title: 'Product Specs Page Product Number',
    tagName: 'ProductSpecsPageProductNumber',
}, {
    url: '/product-specs/product-line/',
    title: 'Product Specs Page Product Line',
    tagName: 'ProductSpecsPageProductLine',
}, {
    url: '/manageorders',
    title: 'Manage Order',
    tagName: 'ManageOrder',
}, {
    url: '/backOrders',
    title: 'Back Orders',
    tagName: 'Back Orders',
}, {
    url: '/order/createOrder',
    title: 'Create Order',
    tagName: 'CreateOrder',
}, {
    url: '/order/editOrder',
    title: 'Edit Order',
    tagName: 'EditOrder',
}, {
    url: '/order/updatebookedorder',
    title: 'Update Booked Order',
    tagName: 'UpdateBookedOrder',
}, {
    url: '/createorder/orderreview',
    title: 'Create Order Review',
    tagName: 'CreateOrderReview',
}, {
    url: '/editorder/orderreview',
    title: 'Edit Order Review',
    tagName: 'EditOrderReview',
}, {
    url: '/order/payByCreditCard',
    title: 'Pay By Credit Card',
    tagName: 'PayByCreditCard',
}, {
    url: '/approvereturns',
    title: 'Approve Returns and Credits',
    tagName: 'ApproveReturns',
}, {
    url: '/approvereturncreditrequest',
    title: 'Approve Return Credit Request',
    tagName: 'ApproveReturnCreditRequest',
}, {
    url: '/requestreturn',
    title: 'Request Return Search',
    tagName: 'RequestReturnSearch',
}, {
    url: '/requestreturnstep1',
    title: 'Request Return Step1',
    tagName: 'RequestReturnStep1',
}, {
    url: '/requestreturnstep2',
    title: 'Request Return Step2',
    tagName: 'RequestReturnStep2',
}, {
    url: '/requestreturnstep3',
    title: 'Request Return Step3',
    tagName: 'RequestReturnStep3',
}, {
    url: '/requestcredit',
    title: 'Request Credit Search',
    tagName: 'RequestCreditSearch',
}, {
    url: '/requestcreditstep1',
    title: 'Request Credit Step1',
    tagName: 'RequestCreditStep1',
}, {
    url: '/requestcreditstep2',
    title: 'Request Credit Step2',
    tagName: 'RequestCreditStep2',
}, {
    url: '/requestcreditstep3',
    title: 'Request Credit Step3',
    tagName: 'RequestCreditStep3',
}, {
    url: '/requestcreditstep4',
    title: 'Request Credit Step4',
    tagName: 'RequestCreditStep4',
}, {
    url: '/requestCreditScrapPolicy',
    title: 'Request Credit Scrap Policy',
    tagName: 'RequestCreditScrapPolicy',
}, {
    url: '/viewrequests',
    title: 'View Requests',
    tagName: 'ViewRequests',
}, {
    url: '/previousreturnandcredit',
    title: 'Previous Return And Credit',
    tagName: 'PreviousReturnAndCredit',
}, {
    url: '/proofofdelivery',
    title: 'Proof Of Delivery',
    tagName: 'ProofOfDelivery',
}, {
    url: '/cancelproducts',
    title: 'Cancel Products',
    tagName: 'CancelProducts',
}, {
    url: '/cancelProducts/confirmation',
    title: 'Cancel Products Confirmation',
    tagName: 'CancelProductsConfirmation',
}, {
    url: '/cancelOrder/confirmation',
    title: 'Cancel Order Confirmation',
    tagName: 'CancelOrderConfirmation',
}, {
    url: '/cancel/bookedorder/confirmation',
    title: 'Cancel BookedOrder Confirmation',
    tagName: 'CancelBookedOrderConfirmation',
}, {
    url: '/update/bookedorder/confirmation',
    title: 'Update BookedOrder Confirmation',
    tagName: 'UpdateBookedOrderConfirmation',
}, {
    url: '/cancel/bookedorder/confirmationError',
    title: 'Cancel BookedOrder Confirmation Error',
    tagName: 'CancelBookedOrderConfirmationError',
}, {
    url: '/update/bookedorder/confirmationError',
    title: 'Update BookedOrder Confirmation Error',
    tagName: 'UpdateBookedOrderConfirmationError',
}, {
    url: '/quickorder',
    title: 'Quick Order',
    tagName: 'QuickOrder',
}, {
    url: '/approve-ncrp',
    title: 'Approve NCRP',
    tagName: 'ApproveNcrp',
}, {
    url: '/orderdetails',
    title: 'Order Details',
    tagName: 'OrderDetails',
}, {
    url: '/viewrequestsorderdetails',
    title: 'View Requests Order Details',
    tagName: 'ViewRequestsOrderDetails',
}, {
    url: '/approvencrporderdetails',
    title: 'Approve NCRP Order Details',
    tagName: 'ApproveNcrpOrderDetails',
}, {
    url: '/packages',
    title: 'Packages',
    tagName: 'Packages',
}, {
    url: '/compare-products/product-number/',
    title: 'Compare Products Product Number',
    tagName: 'CompareProductsProductNumber',
}, {
    url: '/compare-products/product-line/',
    title: 'Compare Products Product Line',
    tagName: 'CompareProductsProductLine',
}, {
    url: '/carrierinformation',
    title: 'carrierinformation',
    tagName: 'carrierinformation',
}, {
    url: '/lookupserialno',
    title: 'lookupserialno',
    tagName: 'lookupserialno',
}, {
    url: '/list',
    title: 'List',
    tagName: 'List',
}, {
    url: '/cart',
    title: 'Cart',
    tagName: 'Cart',
}, {
    url: '/helpdesk',
    title: 'Help Desk',
    tagName: 'Help Desk',
}, {
    url: '/createpricetags',
    title: 'Create Price Tags',
    tagName: 'CreatePriceTags',
}, {
    url: '/create-brochure-step1',
    title: 'Create Brochure Step 1',
    tagName: 'CreateBrochureStep1',
}, {
    url: '/create-brochure-step2',
    title: 'Create Brochure Step 2',
    tagName: 'CreateBrochureStep2',
}, {
    url: '/create-brochure-step3',
    title: 'Create Brochure Step 3',
    tagName: 'CreateBrochureStep3',
}, {
    url: '/create-brochure-step4',
    title: 'Create Brochure Step 4',
    tagName: 'CreateBrochureStep4',
}, {
    url: '/brochure/create/confirmation',
    title: 'Brochure Create Confirmation',
    tagName: 'BrochureCreateConfirmation',
}, {
    url: '/brochure/updated/confirmation',
    title: 'Brochure Updated Confirmation',
    tagName: 'BrochureUpdatedConfirmation',
}, {
    url: '/create-binder-step1',
    title: 'Create Binder Step 1',
    tagName: 'CreateBinderStep1',
}, {
    url: '/create-binder-step2',
    title: 'Create Binder Step 2',
    tagName: 'CreateBinderStep2',
}, {
    url: '/binder/new/confirmation',
    title: 'Binder New Confirmation',
    tagName: 'BinderNewConfirmation',
}, {
    url: '/binder/save/confirmation',
    title: 'Binder Save Confirmation',
    tagName: 'BinderSaveConfirmation',
}, {
    url: '/training',
    title: 'Training',
    tagName: 'Training',
}, {
    url: '/savedbrochures',
    title: 'Saved Brochures',
    tagName: 'Saved Brochures',
}, {
    url: '/pdf-viewer',
    title: 'PDF Viewer',
    tagName: 'PDFViewer',
}, {
    url: '/saved-exports',
    title: 'Saved Exports',
    tagName: 'SavedExports',
}, {
    url: '/price-template/new',
    title: 'New Price Template',
    tagName: 'NewPriceTemplate',
}, {
    url: '/price-template/edit',
    title: 'Edit Price Template',
    tagName: 'EditPriceTemplate',
}, {
    url: '/resources/prestigepif',
    title: 'PrestigePif',
    tagName: 'PrestigePif',
},  {
    url: '/resources/gedistributor',
    title: 'GeDistributor',
    tagName: 'GeDistributor',
},{
    url: '/resources/monogram',
    title: 'Monogram',
    tagName: 'Monogram',
}, {
    url: '/resources/performance',
    title: 'Performance',
    tagName: 'Performance',
}, {
    url: '/resources/mapguidelines',
    title: 'Map Guidelines',
    tagName: 'MapGuidelines',
}, {
    url: '/resources/fullcatalog',
    title: 'Full Catalog',
    tagName: 'FullCatalog',
}, {
    url: '/resources/claimforms',
    title: 'Claim Forms',
    tagName: 'ClaimForms',
}, {
    url: '/resources/pricesheets',
    title: 'Price Sheets',
    tagName: 'PriceSheets',
},{
    url: '/resources/advertisingportal',
    title: 'Advertising Portal',
    tagName: 'AdvertisingPortal',
}, {
    url: '/resources/salesHandbooks',
    title: 'Sales Handbooks',
    tagName: 'SalesHandbooks',
}, {
    url: '/product-purchase-report',
    title: 'Product Purchase Report',
    tagName: 'ProductPurchaseReport',
}, {
    url: '/profile/myProfile',
    title: 'My Profile',
    tagName: 'MyProfile',
}, {
    url: '/profile/manageUsers',
    title: 'My Profile Manage user',
    tagName: 'MyProfileManageuser',
}, {
    url: '/profile/manageUsersPage2/',
    title: 'My Profile Manage user Step 2',
    tagName: 'MyProfileManageuserStep2',
}, {
    url: '/profile/userRequests',
    title: 'My Profile User Requests',
    tagName: 'MyProfileUserRequests',
}, {
    url: '/request-product-price-content',
    title: 'Request Product Price Content',
    tagName: 'RequestProductPriceContent',
}, {
    url: '/error',
    title: 'Error',
    tagName: 'Error',
}, {
    url: '/noRoute',
    title: 'No Route',
    tagName: 'NoRoute',
}];



// WEBPACK FOOTER //
// ./src/App/redux/util/analytics.js